import styles from './index.module.scss'
import { Input, Select, message, DatePicker } from 'antd';
import { useState, useContext, useEffect } from 'react'
import Iconfont from '@utils/Iconfont';
import { AppContext } from '@utils/AppContext';
import API from '@api/api.js';
import { BATCH_IMAGES_TYPE } from '@utils/CONST';
import SelectBtnGroups from '@view/page_v3/components/SelectBtnGroups';
const { RangePicker } = DatePicker;

const ProListpageTop = (props) => {
    const { isProCenter, showMemberSelect } = props
    const { globalOrgInfo } = useContext(AppContext)

    const statusOptions = [
        { value: 'all', label: <span>全部状态</span> },
        { value: 0, label: <span>草稿</span> },
        { value: 1, label: <span>排队中</span> },
        { value: 2, label: <span>生成中</span> },
        { value: 3, label: <span>已完成</span> },
        { value: 4, label: <span>生成失败</span> },
    ]

    // 成员列表
    const [memberList, setMemberList] = useState([]);
    const getListOrgMember = () => {
        API.getListOrgMember({}).then((res) => {
            if (res.code !== 0) return message.error(res.message);
            const list = res.data.filter(item => item.role != 'admin').map(item => ({
                value: item.userId,
                label: item.deleted ? item.orgNickname + '（已移除）' : item.orgNickname,
            }));
            setMemberList(list);
        });
    }
    const memberChange = value => {
        props.getMember(value)
    };

    useEffect(() => {
        getListOrgMember()
    }, [])

    return (
        <div className={styles.ProListpageTop}>
            <div>
                <Select
                    onChange={(value) => props.getProjectType(value)}
                    style={{ width: 160, marginRight: '8px' }}
                    defaultValue={'all'}
                    options={[
                        { value: 'all', label: <span>全部项目类型</span> },
                        { value: BATCH_IMAGES_TYPE.TRYON_BATCH, label: <span>AI试衣</span> },
                        { value: BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH, label: <span>换模特</span> },
                        { value: BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH, label: <span>换背景</span> },
                        { value: BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH, label: <span>同款换色</span> },
                        { value: BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH, label: <span>AI超清</span> },
                        { value: BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH, label: <span>搭配上身</span> },
                        // { value: BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH, label: <span>服装详情页</span> },
                        { value: BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH, label: <span>种草图</span> },
                        { value: BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH, label: <span>图生视频</span> },
                    ]}
                />
                <Select
                    onChange={(value) => props.getProStatus(value)}
                    style={{ width: 160, marginRight: '8px' }}
                    defaultValue={'all'}
                    options={isProCenter ? statusOptions.filter(item => item.key != 'draft') : statusOptions}
                />
                {
                    ((globalOrgInfo?.current?.role == 'admin' && !isProCenter) || showMemberSelect) && <Select
                        style={{ width: 200, marginRight: '8px' }}
                        allowClear
                        value={props.member}
                        onChange={memberChange}
                        placeholder="请选择成员"
                        options={memberList}
                    />
                }

                <RangePicker
                    style={{ width: 250 }}
                    format="YYYY-MM-DD"
                    onChange={(value) => {
                        if (value) {
                            props.getStartTime(value[0].format('YYYY-MM-DD'));
                            props.getEndTime(value[1].format('YYYY-MM-DD'));
                        } else {
                            props.getStartTime(null);
                            props.getEndTime(null);
                        }
                    }}
                />

                <Input
                    allowClear
                    // value={projectName}
                    className={styles.focused}
                    placeholder="搜索项目名称"
                    suffix={<Iconfont type="icon-SearchOutlined" style={{ fontSize: 16, color: '#5b6673' }} />}
                    onChange={(e) => props.getProjectSerial(e.target.value)}
                />
            </div>
            <SelectBtnGroups
                getIsSelected={props.getIsSelected}
                setSelectedList={props.setSelectedList}
                selectedList={props.selectedList}
                isSelectedAll={props.isSelectedAll}
                downLoading={props.downLoading}
                selectAll={props.selectAll}
                deleteClick={props.deleteClick}
                downClick={props.downClick}
                hideDownload={true}
            />
        </div>
    )
}

export default ProListpageTop
